/* EDELHOLZ: Jeder Tisch im Warenkorb hat seine eigene Gruppe (05.10.26, Bestellung D392).
   Vorher trugen Add-ons nur _eh_gruppe/_bild/_finish/Finish. Zwei Tische nacheinander in den Warenkorb:
   gleiche Add-ons beider Tische liefen in EINE Zeile (Menge 2), Werkstatt und Buero sahen nicht, was zu
   welchem Tisch gehoert, und ein entfernter Tisch liess seine Add-ons zurueck.
   - Huelle um window.fetch: Ein POST /cart/add.js mit JSON-Body, der GENAU EINEN Tisch enthaelt (Property
     "Modell" = DeskPURE/DeskPRO/ArcPURE, so schreiben es Kaufbox B, alte Kaufbox und PDP-Minikonfigurator),
     bekommt am Tisch und an allen Zeilen desselben Aufrufs (Add-ons, Zuschlaege, NICHT Ensemble-Moebel):
       _eh_konfig  Gruppen-ID (vorhandene ID der Zuschlaege wird uebernommen, assets/edelholz-zuschlag-kopplung.js)
       Tisch       "1", "2", ... = Tische schon im Warenkorb + 1 (ohne /cart.js nach 2 s: "1"). Ohne Unterstrich,
                   damit Entwurf und Bestellung es zeigen; im Warenkorb nur ab zwei Tischen (snippets/line-item.liquid).
     Alle anderen Requests laufen unveraendert durch, bei jedem Fehler der Original-Request.
   - window.EHTisch fuer die Add-on-Seite (assets/edelholz-addon-seite.js): Tische im Warenkorb lesen und die
     Add-on-Liste eines Tisches per /cart/change.js nachtragen. Und fuer assets/edelholz-zuschlag-kopplung.js:
     ein entferntes Add-on dort wieder austragen (addonAustragen).
   - Nach einem ERFOLGREICHEN Tisch-Add (05.10.26, Philipp-Test DEV): Ausstattung, Add-ons und Ensemble zurueck
     auf den Stand beim Laden, Modell/Groesse/Finish bleiben (Tisch 2 ist meist ein aehnlicher Tisch).
     kaufboxReset(root, state, render)  PDP-Minikonfigurator, sofort nach dem Add und VOR dem Drawer: dessen
                                        Fokusfalle (theme.js) wuerde Klicks ausserhalb schlucken und ihn schliessen.
     nachKauf(root, fn)                 Konfigurator B und alter Konfigurator: die leiten auf /cart um, darum
                                        erst beim pagehide (kein Flackern, bfcache bekommt den sauberen Stand)
                                        und ?features=/?addons= sofort aus der URL (Neuladen per Zurueck).
     Aufgerufen nur aus dem Erfolgszweig der Sections; was in den Warenkorb geht, bleibt unberuehrt.
   Laden: layout/theme.liquid VOR edelholz-contact-hook.js, damit dessen Warenkorb-Zaehler den Add-Aufruf
   samt /cart.js-Vorlauf als laufend sieht. */
(function () {
  if (window.EHTisch) return;

  var TISCH_HANDLES = ['design-schreibtisch-holz', 'deskpro-schreibtisch-mit-schublade-holz', 'arcpure-eckschreibtisch-massivholz'];
  var MODELL = /^(deskpure|deskpro|arcpure)\b/i;
  var ADD = /\/cart\/add(?:\.js)?(?:[?#]|$)/;
  var WARTEN_MS = 2000;
  var root = '/';
  try { root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; } catch (e) {}
  var _f = typeof window.fetch === 'function' ? window.fetch : null;

  function props(it) { return (it && it.properties && typeof it.properties === 'object') ? it.properties : {}; }
  /* Zeile aus /cart.js: Tisch-Handle oder Modell-Property. Bewusst NICHT _eh_gruppe == 'tisch',
     das setzt der Minikonfigurator auch an Sideboard, Couchtisch, Stuhl usw. */
  function istTisch(it) {
    return !!it && (TISCH_HANDLES.indexOf(it.handle) > -1 || MODELL.test(String(props(it).Modell || '').trim()));
  }
  /* Zeile im Add-Payload: dort gibt es kein Handle, nur die Properties */
  function istTischPosten(it) { return !!it && MODELL.test(String(props(it).Modell || '').trim()); }
  function istEnsemble(it) { var p = props(it); return p._eh_gruppe === 'ensemble' || !!p.Ensemble; }
  function neueKonfig() { return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 8); }

  /* Tische im Warenkorb, in Warenkorb-Reihenfolge, mit lesbarer Beschriftung fuer die Tischwahl */
  function tische(cart) {
    var liste = [];
    ((cart && cart.items) || []).forEach(function (it) {
      if (!istTisch(it)) return;
      var p = props(it);
      liste.push({
        key: it.key,
        menge: it.quantity || 1,
        konfig: String(p._eh_konfig || ''),
        nr: String(p.Tisch || ''),
        modell: String(p.Modell || it.product_title || ''),
        groesse: String(p['Größe'] || ''),
        finish: String(p.Finish || ''),
        item: it
      });
    });
    liste.forEach(function (t, i) {
      if (!t.nr) t.nr = String(i + 1);
      t.label = 'Tisch ' + t.nr + ' · ' + [t.modell, t.groesse, t.finish].filter(Boolean).join(' ');
    });
    return liste;
  }
  /* Naechste Tischnummer: Anzahl Tische + 1, aber nie eine schon vergebene (Tisch 1 entfernt, Tisch 2 bleibt) */
  function naechsteNummer(cart) {
    var max = 0, n = 0;
    ((cart && cart.items) || []).forEach(function (it) {
      if (!istTisch(it)) return;
      n++;
      var z = parseInt(props(it).Tisch, 10);
      if (z > max) max = z;
    });
    return Math.max(n, max) + 1;
  }

  /* Payload anreichern (veraendert items). true = angereichert, false = nicht zustaendig */
  function anreichern(items, cart) {
    if (!Array.isArray(items)) return false;
    var t = items.filter(istTischPosten);
    if (t.length !== 1 || props(t[0]).Tisch) return false;
    var tisch = t[0];
    var konfig = String(props(tisch)._eh_konfig || '') || neueKonfig();
    var nr = String(naechsteNummer(cart));
    items.forEach(function (it) {
      if (!it || typeof it !== 'object') return;
      var p = props(it);
      if (it !== tisch && istEnsemble(it)) return;
      if (p._eh_konfig && p._eh_konfig !== konfig) return;
      /* Tisch zuerst, damit Entwurf und Bestellung die Nummer oben zeigen */
      var neu = { Tisch: nr };
      Object.keys(p).forEach(function (k) { if (k !== 'Tisch') neu[k] = p[k]; });
      neu._eh_konfig = konfig;
      it.properties = neu;
    });
    return true;
  }

  function korb() {
    if (!_f) return Promise.resolve(null);
    var lesen = _f.call(window, root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .catch(function () { return null; });
    var uhr = 0;
    var zeit = new Promise(function (ok) { uhr = setTimeout(function () { ok(null); }, WARTEN_MS); });
    return Promise.race([lesen, zeit]).then(function (c) { clearTimeout(uhr); return c; });
  }

  /* Gehoert der Request uns? Liefert { body, items } oder null */
  function tischAdd(input, init) {
    if (!init || typeof init.body !== 'string') return null;
    if (String(init.method || '').toUpperCase() !== 'POST') return null;
    var u = typeof input === 'string' ? input : String((input && (input.href || input.url)) || '');
    if (!ADD.test(u.split('#')[0])) return null;
    var body = JSON.parse(init.body);
    if (!body || !Array.isArray(body.items)) return null;
    var t = body.items.filter(istTischPosten);
    if (t.length !== 1 || props(t[0]).Tisch) return null;
    return { body: body, items: body.items };
  }

  if (_f) {
    window.fetch = function (input, init) {
      var self = this, args = arguments, daten = null;
      try { daten = tischAdd(input, init); } catch (e) { daten = null; }
      if (!daten) return _f.apply(self, args);
      return korb().then(function (cart) {
        var neu = null;
        try {
          if (anreichern(daten.items, cart)) {
            neu = {};
            Object.keys(init).forEach(function (k) { neu[k] = init[k]; });
            neu.body = JSON.stringify(daten.body);
          }
        } catch (e) { neu = null; }
        return neu ? _f.call(self, input, neu) : _f.apply(self, args);
      });
    };
  }

  /* Add-on-Liste des Tisches nachtragen ("Add-ons" lesbar + _eh_addons roh, gleiche Reihenfolge wie
     EHProps.lesbar in assets/edelholz-addon-bild.js; alte Rohform "Name(Wahl)|..." bleibt Rohform).
     Liefert die Antwort von /cart/change.js (mit sections) oder null. Wirft nie. */
  function addonsNachtragen(konfig, lesbar, roh, sections) {
    if (!_f || !konfig || !lesbar) return Promise.resolve(null);
    lesbar = String(lesbar).replace(/,/g, ' ').replace(/\s+/g, ' ').trim();
    roh = String(roh || lesbar).replace(/\|/g, ' ').trim();
    return korb().then(function (cart) {
      var t = tische(cart).filter(function (x) { return x.konfig === konfig; })[0];
      if (!t || !t.key) return null;
      var p = {};
      Object.keys(props(t.item)).forEach(function (k) { var v = t.item.properties[k]; if (v != null && v !== '') p[k] = v; });
      var les = String(p['Add-ons'] || '');
      if (les && (les.indexOf('|') > -1 || les.indexOf('(') > -1)) {
        if (('|' + les + '|').indexOf('|' + roh + '|') > -1) return null;
        p['Add-ons'] = les + '|' + roh;
      } else {
        var teile = les ? les.split(',').map(function (s) { return s.trim(); }) : [];
        if (teile.indexOf(lesbar) > -1) return null;
        p['Add-ons'] = les ? les + ', ' + lesbar : lesbar;
        if (les && !p._eh_addons) p._eh_addons = teile.join('|');
        p._eh_addons = p._eh_addons ? p._eh_addons + '|' + roh : roh;
      }
      var body = { id: t.key, quantity: t.menge, properties: p };
      if (sections) body.sections = sections;
      return _f.call(window, root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r && r.ok ? r.json() : null; });
    }).catch(function () { return null; });
  }

  /* ===== Add-on entfernt: aus der Liste des Tisches austragen (05.10.26) =====
     Entfernt der Kunde eine Add-on-Unterzeile, stand das Add-on sonst weiter in "Add-ons"/_eh_addons des Tisches
     und die Werkstatt haette es gebaut. Handle -> Name wie snippets/eh-cart-unterzeilen.liquid; Eintraege beginnen
     mit dem Namen ("PowerLINK Schwarz", "SoftGLOW(deskpro/deskpure)"). Genau EIN Eintrag je Liste geht raus. */
  var ADDON_NAMEN = {
    'magsafe-addon': 'SmartCHARGE',
    'mittelfach-fur-deskpro-schreibtisch': 'CenterDRAW',
    'auszugsfach-fur-arcpure-schreibtisch': 'CenterDRAW',
    'zusaetzliche-schublade-fur-arcpure': 'SideDRAW',
    'kabelfuehrung-tischbein': 'CableSLOT',
    'schnellzugriff-steckdose': 'PowerPORT',
    'powerlink-ladeanschluss-usb-c-aus-aluminium': 'PowerLINK',
    'led-ambientbeleuchtung-edelholz-schreibtische': 'SoftGLOW',
    'viewprime-monitorarm-aus-aluminium': 'Viewprime',
    'saphirshield-front-blende': 'SaphirSHIELD'
  };
  /* Liste ohne einen Eintrag des Add-ons. Bei mehreren Treffern der mit passender Wahl (Variante), sonst der letzte.
     Liefert den neuen String oder null (kein Treffer). */
  function ohneEintrag(text, trenner, name, wahl) {
    var teile = String(text || '').split(trenner).map(function (s) { return s.trim(); }).filter(Boolean);
    var n = name.toLowerCase(), treffer = -1, passend = -1;
    var wahlen = String(wahl || '').toLowerCase().split('/').map(function (s) { return s.trim(); }).filter(Boolean);
    teile.forEach(function (t, i) {
      var l = t.toLowerCase();
      if (l.slice(0, n.length) !== n || (l.length > n.length && !/[\s(]/.test(l.charAt(n.length)))) return;
      treffer = i;
      var rest = l.slice(n.length).replace(/[()]/g, ' ').trim();
      if (rest && wahlen.indexOf(rest) > -1) passend = i;
    });
    var weg = passend > -1 ? passend : treffer;
    if (weg < 0) return null;
    teile.splice(weg, 1);
    return teile.join(trenner === ',' ? ', ' : trenner);
  }
  /* Neue Properties des Tisches (alle anderen bleiben, leere fallen weg wie bei addonsNachtragen) oder null.
     Leere Liste: Key weg, so wie EHProps.lesbar ohne Add-ons gar keinen Key schreibt. */
  function ohneAddon(tischProps, handle, wahl) {
    var name = ADDON_NAMEN[String(handle || '')];
    if (!name || !tischProps) return null;
    var p = {};
    Object.keys(tischProps).forEach(function (k) { var v = tischProps[k]; if (v != null && v !== '') p[k] = v; });
    var les = String(p['Add-ons'] || ''), roh = String(p._eh_addons || '');
    /* alte Rohform "Name(Wahl)|..." im sichtbaren Key: Trenner | wie dort */
    var lesNeu = les ? ohneEintrag(les, (les.indexOf('|') > -1 || les.indexOf('(') > -1) ? '|' : ',', name, wahl) : null;
    var rohNeu = roh ? ohneEintrag(roh, '|', name, wahl) : null;
    if (lesNeu === null && rohNeu === null) return null;
    if (lesNeu !== null) { if (lesNeu) p['Add-ons'] = lesNeu; else delete p['Add-ons']; }
    if (rohNeu !== null) { if (rohNeu) p._eh_addons = rohNeu; else delete p._eh_addons; }
    return p;
  }
  /* cart = Warenkorb VOR dem Entfernen (/cart.js), key = entfernte Add-on-Zeile. Traegt das Add-on beim Tisch mit
     derselben _eh_konfig aus (/cart/change.js ueber den Tisch-Key, Menge bleibt). Danach hat der Tisch einen neuen Key,
     darum sections mitgeben und neu zeichnen. Nicht fuer Tische selbst. Liefert die Antwort oder null, wirft nie. */
  function addonAustragen(cart, key, sections) {
    try {
      var it = ((cart && cart.items) || []).filter(function (x) { return x && x.key === key; })[0];
      if (!_f || !it || istTisch(it)) return Promise.resolve(null);
      var konfig = String(props(it)._eh_konfig || '');
      var t = konfig && tische(cart).filter(function (x) { return x.konfig === konfig; })[0];
      var p = t && t.key ? ohneAddon(props(t.item), it.handle, it.variant_title) : null;
      if (!p) return Promise.resolve(null);
      var body = { id: t.key, quantity: t.menge, properties: p };
      if (sections) body.sections = sections;
      return _f.call(window, root + 'cart/change.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) { return r && r.ok ? r.json() : null; }).catch(function () { return null; });
    } catch (e) { return Promise.resolve(null); }
  }

  /* ===== Konfigurator nach dem Tisch-Add zuruecksetzen (05.10.26) =====
     Vorauswahl = was beim Laden "aktiv" war (Liquid: block.settings.default / default_choice). Das Asset laeuft
     per defer nach dem Parsen, die Section-Skripte aendern beim Init keine "aktiv"-Klasse, also ist das der
     Stand eines frischen Seitenaufrufs. Gemerkt am Element selbst (wie _bound in den Sections). */
  var STD = '[data-mk-feature] [data-mk-choice].aktiv, [data-mk-addon-choices] [data-mk-achoice].aktiv';
  function merkeStandard() {
    try { document.querySelectorAll(STD).forEach(function (el) { el._ehStd = 1; }); } catch (e) {}
  }
  if (typeof document !== 'undefined' && document.querySelectorAll) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', merkeStandard);
    else merkeStandard();
  }
  function klick(el) { try { el.click(); } catch (e) {} }
  function aktiv(el) { return !!(el && el.classList && el.classList.contains('aktiv')); }
  function standardIn(grp, sel) {
    var s = null;
    grp.querySelectorAll(sel).forEach(function (el) { if (!s && el._ehStd) s = el; });
    return s;
  }
  /* Gruppe ohne Vorauswahl: nichts aktiv, wie beim Laden */
  function alleAus(grp, sel) { grp.querySelectorAll(sel).forEach(function (el) { el.classList.remove('aktiv'); }); }

  /* PDP-Minikonfigurator: ueber seine eigenen Klick-Handler, damit Preis, Zusammenfassung, Zeilenbilder,
     Choice-Preise, Ensemble-Knoepfe und Ensemble-Leiste genau so nachziehen wie bei einem Kundenklick.
     Synthetische Klicks zaehlt der Tracker nicht (isTrusted, edelholz-contact-hook.js). */
  function kaufboxReset(root, state, render) {
    if (!root || !state) return;
    /* 1. Add-on-Ausfuehrung (Position/Farbe) zurueck. Ist das Add-on nicht gewaehlt, waehlt der Klick es
          mit aus (W1-Muster) - Schritt 2 nimmt es wieder raus. */
    root.querySelectorAll('[data-mk-addon-choices]').forEach(function (grp) {
      var s = standardIn(grp, '[data-mk-achoice]');
      if (s) { if (!aktiv(s)) klick(s); } else alleAus(grp, '[data-mk-achoice]');
    });
    /* 2. Add-ons abwaehlen */
    var ad = state.addons || {};
    root.querySelectorAll('[data-mk-addon]').forEach(function (p) { if (ad[p.getAttribute('data-mk-addon')]) klick(p); });
    Object.keys(ad).forEach(function (k) { delete ad[k]; });
    /* 3. Ausstattung (Kabeldurchlass usw.) auf die Vorauswahl, die der Init in state.features uebernimmt */
    var ft = state.features || {};
    root.querySelectorAll('[data-mk-feature]').forEach(function (grp) {
      var s = standardIn(grp, '[data-mk-choice]');
      if (s) { if (!aktiv(s)) klick(s); return; }
      alleAus(grp, '[data-mk-choice]');
      delete ft[grp.getAttribute('data-mk-feature')];
    });
    /* 4. Ensemble abwaehlen (Ausfuehrungs-Chips bleiben, die folgen dem Finish) */
    var en = state.ensemble || {};
    root.querySelectorAll('[data-eh-cross]').forEach(function (k) {
      var b = k.querySelector('[data-eh-cross-add]');
      if (b && en[k.getAttribute('data-eh-cross')]) klick(b);
    });
    Object.keys(en).forEach(function (h) { delete en[h]; });
    if (typeof render === 'function') { try { render(); } catch (e) {} }
  }

  /* Konfigurator B / alter Konfigurator. fn setzt den State zurueck und rendert (in der Section, der State
     ist dort privat): state.addons = {}, state.features = {} (Defaults setzt renderFeatures), updateAll().
     Ensemble-Haken vorher hier raus, danach ein change am Ensemble-Block: renderEnsemble + Summe, die
     B-Spiegelung (Sticky-Leiste) hoert auf change. */
  function nachKauf(root, fn) {
    try {
      var u = new URL(location.href), sp = u.searchParams;
      if (sp.has('features') || sp.has('addons')) {
        sp.delete('features'); sp.delete('addons');
        history.replaceState(history.state, '', u.pathname + u.search + u.hash);
      }
    } catch (e) {}
    var erledigt = false;
    window.addEventListener('pagehide', function () {
      if (erledigt) return;
      erledigt = true;
      try {
        if (root) root.querySelectorAll('[data-ens-check]').forEach(function (c) { c.checked = false; });
        if (typeof fn === 'function') fn();
        var w = root && (root.querySelector('[data-role="ensemble"]') || root);
        if (w) w.dispatchEvent(new Event('change', { bubbles: true }));
      } catch (e) {}
    });
  }

  window.EHTisch = {
    istTisch: istTisch,
    tische: tische,
    naechsteNummer: naechsteNummer,
    anreichern: anreichern,
    korb: korb,
    addonsNachtragen: addonsNachtragen,
    ohneAddon: ohneAddon,
    addonAustragen: addonAustragen,
    kaufboxReset: kaufboxReset,
    nachKauf: nachKauf
  };
})();
